export const BACKEND_URL = 'https://api.rabbitspedition.com';
// export const BACKEND_URL = 'http://192.168.1.104:80'; // localhost
